import { put, call, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';
import API from 'services/api';
import { errorHandler } from 'utils/errorMessages';
import { showSnackbar, setLoading, toggleModal } from 'reducers/ui';
import {
  tripTypeFilterActions,
  tripTypeGridActions,
  tripTypeNS,
} from 'containers/Pages/Tasks/TripTypes';

export function* fetchTripTypeListSaga({ payload }) {
  const { filters, from } = payload;
  try {
    const options = {
      ...filters,
      from,
      archived: get(filters, 'archived', false),
    };
    const { data } = yield call(API.getTripTypeList, options);

    if (data.data !== null) {
      const totalEntries = get(data, 'meta.total');
      yield put(
        tripTypeGridActions.setGridList({ list: data.data, totalEntries }),
      );
    }
    yield put(tripTypeFilterActions.setFilterKey(false));
    yield put(tripTypeGridActions.setForceRefresh(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* createTripTypeSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { tripType } = payload;
    const { status } = yield call(API.createTransportServiceType, tripType);
    if (status === 200) {
      yield put(toggleModal(tripTypeNS));
    }
    yield call(fetchTripTypeListSaga, { payload: { filters: {} } });
    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* updateTripTypeSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { tripId, tripType } = payload;
    const { status } = yield call(
      API.editTransportServiceType,
      tripId,
      tripType,
    );

    if (status === 200) {
      yield put(toggleModal(tripTypeNS));
      yield call(fetchTripTypeDetailsSaga, { payload: { id: tripId } });
    }
    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}
export function* fetchTripTypeDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    const { data } = yield call(API.fetchTripTypeDetail, id);
    if (data.data) {
      yield put(tripTypeGridActions.setGridRowDetails({ details: data.data }));
    }
    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* tripTypeSaga() {
  yield takeLatest(tripTypeGridActions.fetchGridList, fetchTripTypeListSaga);
  yield takeLatest(
    tripTypeGridActions.fetchGridRowDetails,
    fetchTripTypeDetailsSaga,
  );
  yield takeLatest(tripTypeGridActions.createRowEntry, createTripTypeSaga);
  yield takeLatest(tripTypeGridActions.updateRowEntry, updateTripTypeSaga);
}
